import Notification from "../Components/Notifications";
const Notifications = () => {
 return(
  <div className="Page">
   <Notification />
  </div>
 );
}
export default Notifications;